import { Tab } from "../../core/ui/Tab";


export function DocumentsTabContent(props: {

}) {

	return (
		<div>Coming soon</div>
	);
}